// src/config/categoryConfig.js - İKİ SEVİYELİ KATEGORİ SİSTEMİ

export const CATEGORY_CONFIG = {
  'Gıda & İçecek': {
    emoji: '🥂',
    subcategories: {
      'Zeytinyağı': { emoji: '🫒' },
      'Kahve': { emoji: '☕' },
      'Çay': { emoji: '🍵' },
      'Gazlı İçecekler': { emoji: '🥤' },
      'Meyve Suları': { emoji: '🧃' },
      'Su': { emoji: '💧' },
      'Süt Ürünleri': { emoji: '🥛' },
      'Tahıllar & Bakliyat': { emoji: '🌾' },
      'Makarna & Pirinç': { emoji: '🍝' },
      'Konserve & Hazır Gıda': { emoji: '🥫' },
      'Baharat & Çeşni': { emoji: '🧂' },
      'Atıştırmalık': { emoji: '🍿' },
      'Tatlı & Çikolata': { emoji: '🍫' },
      'Fırın Ürünleri': { emoji: '🥖' },
      'Meyve & Sebze': { emoji: '🥗' },
      'Et & Balık': { emoji: '🍖' },
      'Stick': { emoji: '🧂' },
      'Kakao': { emoji: '🍫' },
      'Pekmez': { emoji: '🍯' },
      'Doğal Köy Ürünleri': { emoji: '🌿' },
      'Susam': { emoji: '🌾' },
      'Soslar': { emoji: '🥫' }
    }
  },
  'Ev & Mutfak': {
    emoji: '🏠',
    subcategories: {
      'Bardak & Fincan': { emoji: '☕' },
      'Tabak & Kase': { emoji: '🍽️' },
      'Çatal & Kaşık': { emoji: '🍴' },
      'Mutfak Gereçleri': { emoji: '🔪' },
      'Saklama Kapları': { emoji: '🫙' },
      'Termos & Matara': { emoji: '🍶' },
      'Kül Tablası': { emoji: '🚬' },
      'Dekorasyon': { emoji: '🕯️' },
      'Temizlik Ürünleri': { emoji: '🧹' },
      'Çamaşır & Bulaşık': { emoji: '🧼' },
      'Tekstil Ürünleri': { emoji: '🛏️' }
    }
  },
  'Kişisel Bakım': {
    emoji: '💄',
    subcategories: {
      'Cilt Bakımı': { emoji: '🧴' },
      'Saç Bakımı': { emoji: '💇' },
      'Ağız Bakımı': { emoji: '🪥' },
      'Parfüm & Deodorant': { emoji: '💐' },
      'Makyaj': { emoji: '💅' },
      'Tıraş Ürünleri': { emoji: '🪒' },
      'Hijyen Ürünleri': { emoji: '🧻' },
      'Sağlık Ürünleri': { emoji: '💊' }
    }
  },
  'Elektronik': {
    emoji: '📱',
    subcategories: {
      'Telefon & Aksesuar': { emoji: '📱' },
      'Bilgisayar & Tablet': { emoji: '💻' },
      'Kulaklık & Ses': { emoji: '🎧' },
      'Kamera & Fotoğraf': { emoji: '📷' },
      'Şarj Cihazları': { emoji: '🔌' },
      'Akıllı Saat': { emoji: '⌚' },
      'TV & Görüntü': { emoji: '📺' },
      'Oyun & Konsol': { emoji: '🎮' }
    }
  },
  'Hobi & Yaşam': {
    emoji: '🎨',
    subcategories: {
      'Kitap': { emoji: '📚' },
      'Kırtasiye': { emoji: '✏️' },
      'Oyuncak': { emoji: '🧸' },
      'Spor & Outdoor': { emoji: '⚽' },
      'Müzik Aletleri': { emoji: '🎸' },
      'El Sanatları': { emoji: '🧶' },
      'Bahçe & Bitki': { emoji: '🌱' },
      'Oto Aksesuar': { emoji: '🚗' },
      'Seyahat': { emoji: '🧳' }
    }
  },
  'Bebek & Çocuk': {
    emoji: '👶',
    subcategories: {
      'Bebek Gıdası': { emoji: '🍼' },
      'Bebek Bezi': { emoji: '🧷' },
      'Bebek Bakımı': { emoji: '🛁' },
      'Çocuk Giyim': { emoji: '👕' },
      'Oyuncak': { emoji: '🧸' },
      'Okul Ürünleri': { emoji: '🎒' }
    }
  },
  'Giyim & Aksesuar': {
    emoji: '👔',
    subcategories: {
      'Erkek Giyim': { emoji: '👔' },
      'Kadın Giyim': { emoji: '👗' },
      'Ayakkabı': { emoji: '👟' },
      'Çanta': { emoji: '👜' },
      'Saat': { emoji: '⌚' },
      'Takı': { emoji: '💍' },
      'Aksesuar': { emoji: '🎀' }
    }
  },
  'Evcil Hayvan': {
    emoji: '🐾',
    subcategories: {
      'Köpek Ürünleri': { emoji: '🐕' },
      'Kedi Ürünleri': { emoji: '🐈' },
      'Kuş Ürünleri': { emoji: '🐦' },
      'Balık & Akvaryum': { emoji: '🐠' },
      'Kemirgen Ürünleri': { emoji: '🐹' }
    }
  }
};

// Yardımcı Fonksiyonlar

/**
 * Kategori emoji'sini döndürür
 */
export const getCategoryEmoji = (mainCategory, subCategory = null) => {
  if (!mainCategory) return '📦';
  
  const main = CATEGORY_CONFIG[mainCategory];
  if (!main) return '📦';
  
  if (subCategory && main.subcategories[subCategory]) {
    return main.subcategories[subCategory].emoji;
  }
  
  return main.emoji;
};

/**
 * Tüm ana kategorileri döndürür
 */
export const getMainCategories = () => {
  return Object.keys(CATEGORY_CONFIG);
};

/**
 * Belirli bir ana kategorinin alt kategorilerini döndürür
 */
export const getSubCategories = (mainCategory) => {
  if (!mainCategory || !CATEGORY_CONFIG[mainCategory]) return [];
  return Object.keys(CATEGORY_CONFIG[mainCategory].subcategories);
};

/**
 * Tüm kategorileri düz liste olarak döndürür (admin panel için)
 */
export const getAllCategoriesFlat = () => {
  const result = [];
  Object.entries(CATEGORY_CONFIG).forEach(([mainCat, data]) => {
    result.push({
      value: mainCat,
      label: `${data.emoji} ${mainCat}`,
      type: 'main',
      emoji: data.emoji
    });
    
    Object.entries(data.subcategories).forEach(([subCat, subData]) => {
      result.push({
        value: `${mainCat} > ${subCat}`,
        label: `${data.emoji} ${mainCat} > ${subData.emoji} ${subCat}`,
        mainCategory: mainCat,
        subCategory: subCat,
        type: 'sub',
        emoji: subData.emoji
      });
    });
  });
  return result;
};

/**
 * Kategori görüntüleme için emoji + text STRING döndürür (React render için)
 * @param {string} categoryValue - Veritabanından gelen kategori değeri
 * @param {boolean} emojiOnly - Sadece emoji döndürmek için
 * @returns {string} "emoji text" formatında string VEYA sadece emoji
 */
export const getCategoryDisplay = (categoryValue, emojiOnly = false) => {
  if (!categoryValue) return emojiOnly ? '📦' : '📦 Kategorisiz';
  
  // "Ana Kategori > Alt Kategori" formatında mı?
  if (categoryValue.includes(' > ')) {
    const [main, sub] = categoryValue.split(' > ');
    const mainData = CATEGORY_CONFIG[main];
    if (mainData && mainData.subcategories[sub]) {
      const emoji = mainData.subcategories[sub].emoji;
      if (emojiOnly) return emoji;
      return `${emoji} ${main} > ${sub}`;
    }
  }
  
  // Sadece ana kategori
  const mainData = CATEGORY_CONFIG[categoryValue];
  if (mainData) {
    if (emojiOnly) return mainData.emoji;
    return `${mainData.emoji} ${categoryValue}`;
  }
  
  // Bilinmeyen kategori
  if (emojiOnly) return '📦';
  return `📦 ${categoryValue}`;
};

/**
 * Kategori bilgilerini OBJE olarak döndürür (component içinde detaylı kullanım için)
 * @param {string} categoryValue - Veritabanından gelen kategori değeri
 * @returns {Object} { emoji, text, mainCategory, subCategory, mainEmoji? }
 */
export const getCategoryInfo = (categoryValue) => {
  if (!categoryValue) return { emoji: '📦', text: 'Kategorisiz', mainCategory: null, subCategory: null };
  
  // "Ana Kategori > Alt Kategori" formatında mı?
  if (categoryValue.includes(' > ')) {
    const [main, sub] = categoryValue.split(' > ');
    const mainData = CATEGORY_CONFIG[main];
    if (mainData && mainData.subcategories[sub]) {
      return {
        emoji: mainData.subcategories[sub].emoji,
        mainEmoji: mainData.emoji,
        text: `${main} > ${sub}`,
        mainCategory: main,
        subCategory: sub
      };
    }
  }
  
  // Sadece ana kategori
  const mainData = CATEGORY_CONFIG[categoryValue];
  if (mainData) {
    return {
      emoji: mainData.emoji,
      text: categoryValue,
      mainCategory: categoryValue,
      subCategory: null
    };
  }
  
  return { emoji: '📦', text: categoryValue, mainCategory: null, subCategory: null };
};

export default CATEGORY_CONFIG;